export const buyerUrl = {
  root: (buyerId: number) => `/buyers/${buyerId}`,
};
